import './Switch.css'

interface SwitchProps {
  on: boolean
  disabled?: boolean
}

/** The visual of a toggle. The row that holds it is the button and carries the label. */
export function Switch({ on, disabled = false }: SwitchProps) {
  return (
    <span className={`switch ${on ? 'switch--on' : ''} ${disabled ? 'switch--disabled' : ''}`} aria-hidden="true">
      <span className="switch__knob" />
    </span>
  )
}
